// // lottie-loader.service.ts
// import { Injectable } from '@angular/core';
// import { BehaviorSubject } from 'rxjs';

// @Injectable({
//   providedIn: 'root'
// })
// export class LottieLoaderService {
//   private loading = new BehaviorSubject<boolean>(false);
//   public isLoading$ = this.loading.asObservable();

//   show() {
//     this.loading.next(true);
//   }

//   hide() {
//     this.loading.next(false);
//   }
// }


// src/app/services/loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LottieLoaderService {
  private loaderSubject = new BehaviorSubject<boolean>(false);
  loaderState = this.loaderSubject.asObservable();

  show() {
    this.loaderSubject.next(true);
  }

  hide() {
    this.loaderSubject.next(false);
  }
}

